import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import LegalNotice from "./sections/LegalNotice";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div className="w-full bg-background">
      <Header />
      <LegalNotice />
      <Footer />
    </div>;
}